import { render } from "./InformeCalidadOperarios.vue?vue&type=template&id=527cd174&scoped=true"
import script from "./InformeCalidadOperarios.vue?vue&type=script&lang=js"
export * from "./InformeCalidadOperarios.vue?vue&type=script&lang=js"

import "./InformeCalidadOperarios.vue?vue&type=style&index=0&id=527cd174&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527cd174"]])

export default __exports__